import React from 'react';

const typing = (target: EventTarget | null): boolean => {
    if (!(target instanceof HTMLElement)) return false;
    return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName) || Boolean(target.closest('[role="dialog"]'));
};

export function useSlashFocus(ref: React.RefObject<HTMLInputElement | null>) {
    React.useEffect(() => {
        const onKey = (event: KeyboardEvent) => {
            if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey || event.defaultPrevented || typing(event.target)) return;
            const input = ref.current;
            if (!input || !input.offsetParent) return;
            event.preventDefault();
            input.focus();
            input.select();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [ref]);
}

export default useSlashFocus;
